<div class="qa-io-overlay" *ngIf="visible" (click)="onBackdropClick($event)">
  <div class="card qa-io-dialog" role="dialog" aria-modal="true">
    <div class="card-header">
      <span><i class="fa fa-retweet" aria-hidden="true"></i> {{_(KEYS.EDITOR.QUESTIONNAIRE_JSON)}}</span>
      <button type="button" class="close" (click)="hide()" aria-label="Close">
        <i class="fa fa-close" aria-hidden="true"></i>
      </button>
    </div>
    <div class="card-body">
      <textarea #qaIO class="form-control" spellcheck="false"></textarea>
    </div>
    <div class="card-footer">
      <button class="btn btn-success" (click)="importJSON(qaIO.value)">
        <i class="fa fa-upload"></i> {{_(KEYS.EDITOR.IMPORT)}}
      </button>
      <button class="btn btn-success" (click)="exportJSON(qaIO)">
        <i class="fa fa-download"></i> {{_(KEYS.EDITOR.EXPORT)}}
      </button>

      <div class="qa-io-debug">
        <div ngbDropdown container="body" placement="top-right">
          <button class="btn btn-danger" ngbDropdownToggle>
            <i class="fa fa-code-fork"></i>
            {{_(KEYS.EDITOR.DEBUGGING)}}
          </button>
          <div ngbDropdownMenu>
            <button class="dropdown-item qa-cursor-pointer" (click)="exportJSON(qaIO, true)">
              <i class="fa fa-file-code-o"></i>
              {{_(KEYS.EDITOR.UNPACKED_EXPORT)}}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
